import { Typography } from "antd";
import React from "react";
import { COLORS } from "../../../constants";

const { Text } = Typography;
const UnCheckChildren = ({ children }) => {
  return (
    <Text strong style={{ color: COLORS.black }}>
      {children}
    </Text>
  );
};

export default UnCheckChildren;
